import React from "react"
import UrlTaggedText from "../common/UrlTaggedText"
export function FieldLabel({ text }: { text: string }): JSX.Element {
  return <UrlTaggedText className={`text-sm font-semibold text-cents-black`} content={text} />
}